import { format } from "date-fns";

const SHORT_DATE_FNS_FORMAT = "dd-MMM-yyyy HH:mm"; // 21-Sep-2026 12:06
const LONG_DATE_FNS_FORMAT = "dd-MMMM-yyyy HH:mm:ss"; // 21-September-2026 12:06:34

export const formatterShort = (value: string | Date) => {
  return format(value, SHORT_DATE_FNS_FORMAT);
};

// NOT used, because not required, but MIGHT be needed after Business change their mind
export const formatterLong = (value: string) => {
  return format(value, LONG_DATE_FNS_FORMAT);
};

// Value "en" is used as part of JSON file with translations strings
// As result it defines if useTranslation() returns proper data
// If decision will be to change to `en-US`, then need to change also file name and code inside of i18n.ts
export const PREFERRED_LANGUAGE = "en";
